import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import T from 'i18n-react';
import RadarChart from '../../core/Reviews/RadarChart';
import Rating from '../../core/Reviews/Rating';

const useStyles = makeStyles((theme) => ({
  box: {
    position: 'relative',
    marginBottom: '10px',
    marginTop: '5px',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& > div > div > div > a': {
      padding: '0 0 0 60%',
    },
    '& > div > div > div': {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'right',
      },
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  subtitle: {
    paddingBottom: theme.spacing(2),
    fontSize: 'small',
    letterSpacing: '0.3px',
    color: 'gray',
  },
}));

export type AtmosphereReviewProps = {
  options: Array<{
    name: string;
    portion: number;
  }>;
  color: string;
  rating: string;
};

const AtmosphereReview = ({
  options,
  color,
  rating,
}: AtmosphereReviewProps) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.subtitle}>
        {T.translate('reviewContainer.subtitle')}
      </Typography>
      <div className={classes.box}>
        <Grid container alignItems="center">
          <Grid item xs={12} sm={4}>
            <Typography className={classes.title}>
              {T.translate('atmosphereReview.title')}
            </Typography>
            <Rating>{rating} / 5.0</Rating>
          </Grid>
          <Grid item xs={12} sm={8}>
            <RadarChart options={options} bgColor={color} />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AtmosphereReview;
